import {ROWS_PER_PAGE} from '../constants/rowsPerPage';

export function getScrollAttemptedOffsetAfterPage(page: number = 1): number {
  return (page - 1) * ROWS_PER_PAGE + ROWS_PER_PAGE;
}
